const resolvePadding = size => {
  const map = {
    small: '8px 8px',
    sm: '8px 8px',
    medium: '12px 12px',
    md: '12px 12px',
    large: '14px 16px',
    lg: '14px 16px'
  };
  return map[size || 'medium'];
};
export const toggleButtonDefaultStyle = (theme, size, index, toggleGroupLength) => ({
  backgroundColor: `${theme.tokens.ComponentToggleGroupButtonBg}`,
  border: `1px solid ${theme.tokens.ComponentToggleGroupButtonBorder}`,
  color: `${theme.tokens.ComponentToggleGroupButtonColor}`,
  textTransform: 'none',
  width: '100%',
  fontSize: size === 'large' ? '20px' : size === 'medium' ? '16px' : '14px',
  '&.Mui-selected': {
    backgroundColor: `${theme.tokens.ComponentToggleGroupButtonSelectedBg}`,
    color: `${theme.tokens.ComponentToggleGroupButtonSelectedColor}`,
    '&::before': {
      content: "' '",
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '100%',
      height: '4px',
      borderBottomLeftRadius: index === 0 ? '3px' : '',
      borderBottomRightRadius: index === toggleGroupLength - 1 ? '3px' : '',
      backgroundColor: `${theme.tokens.ComponentToggleGroupButtonSelectedBorderBottom}`
    },
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  '&.MuiToggleButtonGroup-grouped:not(:first-of-type)': {
    borderLeft: `1px solid ${theme.tokens.ComponentToggleGroupButtonSelectedBorderLeft}`
  },
  '&:hover': {
    backgroundColor: `${theme.tokens.ComponentToggleGroupButtonHoverBg}`
  },
  '&.MuiToggleButtonGroup-grouped': {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    gap: size === 'small' || size === 'sm' ? '6px' : '8px',
    padding: resolvePadding(size),
    overflow: 'hidden'
  }
});
export const toggleButtonGroupDefaultStyle = (theme, size, toggleWidth) => ({
  borderColor: `${theme.tokens.ComponentToggleGroupButtonBorder}`,
  height: size === 'large' ? '48px' : size === 'medium' ? '40px' : '32px',
  width: toggleWidth ? toggleWidth : '100%',
  whiteSpace: 'nowrap'
});
export const iconButtonGroupDefaultStyle = size => ({
  display: 'flex',
  fontSize: size === 'large' ? '20px' : size === 'medium' ? '16px' : '14px'
});